import axios from 'ps-components/lib/apiClient';
import { useQuery } from 'react-query';
import { QueryKeys } from '../../constants/query-keys';

export type MarketElementResponse = {
  payElements: {
    source_field: string
    field_title: string
  }[]
}

export const useMarketElements = () => {
  const getMarketElements = async (): Promise<MarketElementResponse> => {
    const response = await axios.apiGet(`/api/market-pricing/global-job-pricing/getMarketElements`)
    return response.data
  }

  const query = useQuery([QueryKeys.GLO_JAM_MARKET_ELEMENTS, { notEmpty: true }], getMarketElements, { staleTime: Infinity })

  return query
}
